// Ionic Angular

import { Component } from '@angular/core';


@Component({
    selector: 'tidy-card-header',
    template: `
          <div class="tidy-container">
            <div class="tidy-item no-wrap">
              <ng-content select="[item-left]"></ng-content>
            </div>
            <div class="tidy-item" item-left>
              <ng-content select="[item-label]"></ng-content>
            </div>
            <div class="tidy-item">
              <ng-content select="[item-right]"></ng-content>
            </div>
          </div>
        `,
    standalone: false
})
export class TidyCardHeader { }
